import { mobx } from '@/lib/mobx';
import { cryptoCurrencies } from '@/config/constants';

export const formatSign = (sign?: string) => {
  const currancySign = sign || mobx.profile.currency.sign || '$';
  const isCurrencyToUpperCase = currancySign.length > 1 && !cryptoCurrencies.includes(currancySign);

  return isCurrencyToUpperCase ? currancySign.toUpperCase() : currancySign;
};

export const formatCurrencyNumber = (num?: number | string) => {
  const sum = isNaN(Number(num)) || !num ? 0 : mobx.profile.roundCurrency(Number(num));

  return sum;
};

interface FormatCurrencyParams {
  num: Parameters<typeof formatCurrencyNumber>[0];
  currency?: Parameters<typeof formatSign>[0];
}
export const formatCurrency = ({ num, currency }: FormatCurrencyParams) => {
  const formattedSign = formatSign(currency);
  const formattedNum = formatCurrencyNumber(num);

  const currenciesToEnd = ['₽', '₴', 'mBTC'];

  const isLeftToRight = currenciesToEnd.includes(formattedSign) || formattedSign.length > 1;

  return isLeftToRight ? `${formattedNum} ${formattedSign}` : `${formattedSign}${formattedNum}`;
};
